import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { AlgorithmUrl } from './AlgorithmUrl';

const deleteAlgorithmsByIds = async (algorithmIds: number[]) => {
  if (Array.isArray(algorithmIds) && algorithmIds.length > 0) {
    return apiClient.delete(expand(AlgorithmUrl.BY_IDS, { algorithmIds }));
  }
};

export const useDeleteAlgorithmsByIdsMutation = createApiMutationHook(
  ['deleteAlgorithmsByIds'],
  deleteAlgorithmsByIds
);
